import { SettingsManager } from '@classes/settingsManager';
import { Middleware } from '@reduxjs/toolkit';

import { addItem, clearCart, removeItem, setCart, updateQuantity } from './cartSlice';

const LS_KEY = 'guest_cart';

export const cartMiddleware: Middleware = (store) => (next) => (action) => {
    const result = next(action);

    const state = store.getState();
    const creds = SettingsManager.getConnectionCredentials();
    const isAuthenticated = !!creds?.userId;

    const cartActions = [
        addItem.type,
        removeItem.type,
        updateQuantity.type,
        clearCart.type,
        setCart.type,
    ];

    if (cartActions.includes(action.type)) {
        if (!isAuthenticated) {
            localStorage.setItem(LS_KEY, JSON.stringify(state.cart.items));
        } else {
            // TODO: отправка на бек
            console.log('Синхронизация с беком');
            localStorage.setItem(LS_KEY, JSON.stringify(state.cart.items));
        }
    }

    return result;
};

export const loadCartFromLS = (): CartItem[] => {
    try {
        const raw = localStorage.getItem(LS_KEY);
        return raw ? JSON.parse(raw) : [];
    } catch {
        return [];
    }
};
